// extracted by mini-css-extract-plugin
module.exports = {"background":"Background-module--background--27e63"};